import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useState } from "react";
import { tableMapper } from "layout/settings/tableMapper";
import {
  containsRowWithErrors,
  setListOnUpdate,
} from "layout/settings/tableHelpers";
import Table, {
  styledTable,
} from "@visiblethread/react-components/dist/components/Table";
import { tableVariants } from "@visiblethread/react-components/dist/components/Table/constants";
import Header from "layout/settings/readabilityIgnoreList/Header";
import SubHeader from "layout/settings/readabilityIgnoreList/SubHeader";
import { fetchReadabilityIgnoreList } from "slices/settings/actions/readabilityIgnoreList";
import {
  addNewTerm,
  deleteTerm,
  setEditedList,
} from "slices/settings/slices/readabilityIgnoreSlice";
import { setActiveTab } from "slices/settings/slices/activeTabSlice";
import { selectReadabilityIgnore } from "slices/settings/selectors";
import {createValidations} from "../validation";

const ReadabilityIgnoreList = () => {
  const dispatch = useDispatch();
  const { editMode, ignoreList, selectedIndex } = useSelector(
    selectReadabilityIgnore
  );

  const [rows, setRows] = useState([]);
  const [selectedRowIndex, setSelectedRowIndex] = useState(0);
  const [selectedColumnIndex, setSelectedColumnIndex] = useState(0);
  const [hasErrors, setHasErrors] = useState(false);

  const validations = createValidations({
    validateEmpty: true,
    validateDuplicates: true,
  });

  const { getHeader, getRows, getState } = tableMapper(
    dispatch,
    editMode,
    addNewTerm,
    deleteTerm,
    validations
  );

  const setNewList = () => {
    dispatch(setEditedList(getState(rows)));
  };

  useEffect(() => {
    dispatch(fetchReadabilityIgnoreList());
    dispatch(setActiveTab(2));
  }, [dispatch]);

  useEffect(() => {
    setSelectedRowIndex(0);
    setSelectedColumnIndex(0);
  }, [editMode]);

  useEffect(() => {
    setRows(getRows(ignoreList));
  }, [ignoreList, editMode]);

  useEffect(() => {
    setListOnUpdate(rows, getRows, ignoreList, setNewList);
    setHasErrors(containsRowWithErrors(rows));
  }, [rows]);

  useEffect(() => {
    setSelectedRowIndex(selectedIndex);
  }, [selectedIndex]);

  return (
    <>
      <Header hasErrors={hasErrors} />
      <SubHeader selectedRowIndex={selectedRowIndex} />
      <Table
        id="readability_ignore_list-table"
        dataTestId="readability_ignore_list-table"
        content={{ header: getHeader(), rows, setRows }}
        config={{
          variant: tableVariants.plain,
          editable: editMode,
          draggable: editMode,
          table: styledTable.excel,
          resizable: true,
          persistSettings: true,
          selectedRowIndex,
          selectedColumnIndex,
          setSelectedRowIndex,
          setSelectedColumnIndex,
        }}
      />
    </>
  );
};

export default ReadabilityIgnoreList;
